import { Box, Button, Container, Stack, Typography } from "@mui/material";
import NotAuthorizedIcon from "assets/icons/NotAuthorizedIcon";
import React from "react";
import { useNavigate } from "react-router-dom";

export const NotAuthorized = () => {
    const navigate = useNavigate();

    const goHome = () => {
        navigate("/");
    };

    return (
        <Container>
            <Stack
                alignItems="center"
                justifyContent="center"
                gap={2}
                sx={{ height: "100dvh" }}
            >
                <Box width="150px">
                    <NotAuthorizedIcon width="100%" />
                </Box>

                <Typography variant="h2" color="primary" fontWeight="bold">
                    401
                </Typography>
                <Typography variant="h5">Unauthorized</Typography>
                <Typography variant="body1" color="grey.600">
                    You can't access this resource
                </Typography>
                <Button variant="outlined" onClick={goHome}>
                    Go home
                </Button>
            </Stack>
        </Container>
    );
};

export default NotAuthorized;
